import { schema } from 'normalizr';

const skillSchema = new schema.Entity('skills');

export default skillSchema;
